//# sourceMappingURL=html.mjs.map
/// <reference types="./html.d.mts" />
import * as $redraw from "../../../redraw/redraw.mjs";
import { toList } from "../../gleam.mjs";
import * as $attribute from "../../redraw/dom/attribute.mjs";
import { toProps as to_props } from "./html.ffi.mjs";

export { to_props };

const convert_children = true;

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Reference/Elements)
 */
export function element(tag, attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx(tag, props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/html)
 */
export function html(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("html", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/link)
 */
export function link(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("link", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/meta)
 */
export function meta(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("meta", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/API/Text)
 */
export function text(content) {
  return $redraw.jsx("text_", undefined, content, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/script)
 */
export function script(attrs, script) {
  let props = to_props(attrs);
  return $redraw.jsx("script", props, toList([text(script)]), convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/style)
 */
export function style(attrs, content) {
  let props = to_props(attrs);
  return $redraw.jsx("style", props, toList([text(content)]), convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/title)
 */
export function title(attrs, content) {
  let props = to_props(attrs);
  return $redraw.jsx("title", props, toList([text(content)]), convert_children);
}

/**
 * Empty node. Does not render anything in the DOM.
 */
export function none() {
  return $redraw.jsx("none_", undefined, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/a)
 */
export function a(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("a", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/abbr)
 */
export function abbr(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("abbr", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/address)
 */
export function address(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("address", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/area)
 */
export function area(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("area", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/article)
 */
export function article(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("article", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/aside)
 */
export function aside(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("aside", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/audio)
 */
export function audio(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("audio", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/b)
 */
export function b(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("b", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/base)
 */
export function base(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("base", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/bdi)
 */
export function bdi(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("bdi", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/bdo)
 */
export function bdo(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("bdo", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/blockquote)
 */
export function blockquote(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("blockquote", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/body)
 */
export function body(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("body", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/br)
 */
export function br(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("br", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/button)
 */
export function button(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("button", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/canvas)
 */
export function canvas(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("canvas", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/caption)
 */
export function caption(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("caption", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/cite)
 */
export function cite(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("cite", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/code)
 */
export function code(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("code", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/col)
 */
export function col(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("col", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/colgroup)
 */
export function colgroup(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("colgroup", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/data)
 */
export function data(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("data", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/datalist)
 */
export function datalist(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("datalist", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/dd)
 */
export function dd(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("dd", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/del)
 */
export function del(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("del", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/details)
 */
export function details(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("details", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/dfn)
 */
export function dfn(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("dfn", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/dialog)
 */
export function dialog(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("dialog", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/div)
 */
export function div(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("div", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/dl)
 */
export function dl(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("dl", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/dt)
 */
export function dt(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("dt", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/em)
 */
export function em(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("em", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/embed)
 */
export function embed(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("embed", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/fieldset)
 */
export function fieldset(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("fieldset", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/figcaption)
 */
export function figcaption(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("figcaption", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/figure)
 */
export function figure(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("figure", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/footer)
 */
export function footer(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("footer", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/form)
 */
export function form(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("form", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h1)
 */
export function h1(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h1", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h2)
 */
export function h2(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h2", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h3)
 */
export function h3(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h3", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h4)
 */
export function h4(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h4", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h5)
 */
export function h5(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h5", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/h6)
 */
export function h6(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("h6", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/head)
 */
export function head(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("head", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/header)
 */
export function header(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("header", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/hgroup)
 */
export function hgroup(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("hgroup", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/hr)
 */
export function hr(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("hr", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/i)
 */
export function i(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("i", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/iframe)
 */
export function iframe(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("iframe", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/img)
 */
export function img(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("img", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/input)
 */
export function input(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("input", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/ins)
 */
export function ins(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("ins", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/kbd)
 */
export function kbd(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("kbd", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/label)
 */
export function label(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("label", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/legend)
 */
export function legend(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("legend", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/li)
 */
export function li(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("li", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/main)
 */
export function main(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("main", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/map)
 */
export function map(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("map", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/mark)
 */
export function mark(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("mark", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/menu)
 */
export function menu(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("menu", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/meter)
 */
export function meter(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("meter", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/nav)
 */
export function nav(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("nav", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/noscript)
 */
export function noscript(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("noscript", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/object)
 */
export function object(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("object", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/ol)
 */
export function ol(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("ol", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/optgroup)
 */
export function optgroup(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("optgroup", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/option)
 */
export function option(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("option", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/output)
 */
export function output(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("output", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/p)
 */
export function p(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("p", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/picture)
 */
export function picture(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("picture", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/pre)
 */
export function pre(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("pre", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/progress)
 */
export function progress(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("progress", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/q)
 */
export function q(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("q", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/rp)
 */
export function rp(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("rp", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/rt)
 */
export function rt(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("rt", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/ruby)
 */
export function ruby(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("ruby", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/s)
 */
export function s(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("s", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/samp)
 */
export function samp(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("samp", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/section)
 */
export function section(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("section", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/select)
 */
export function select(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("select", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/slot)
 */
export function slot(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("slot", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/small)
 */
export function small(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("small", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/source)
 */
export function source(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("source", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/span)
 */
export function span(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("span", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/strong)
 */
export function strong(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("strong", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/sub)
 */
export function sub(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("sub", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/summary)
 */
export function summary(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("summary", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/sup)
 */
export function sup(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("sup", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/table)
 */
export function table(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("table", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/tbody)
 */
export function tbody(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("tbody", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/td)
 */
export function td(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("td", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/template)
 */
export function template(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("template", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/textarea)
 */
export function textarea(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("textarea", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/tfoot)
 */
export function tfoot(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("tfoot", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/th)
 */
export function th(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("th", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/thead)
 */
export function thead(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("thead", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/time)
 */
export function time(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("time", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/tr)
 */
export function tr(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("tr", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/track)
 */
export function track(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("track", props, undefined, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/u)
 */
export function u(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("u", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/ul)
 */
export function ul(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("ul", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/var)
 */
export function var$(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("var", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/video)
 */
export function video(attrs, children) {
  let props = to_props(attrs);
  return $redraw.jsx("video", props, children, convert_children);
}

/**
 * [Documentation](https://developer.mozilla.org/docs/Web/HTML/Element/wbr)
 */
export function wbr(attrs) {
  let props = to_props(attrs);
  return $redraw.jsx("wbr", props, undefined, convert_children);
}
